import { useMutation } from "@apollo/client";
import { EditGoalMutation, EditGoalMutationVariables } from "@ctypes";
import { EDIT_GOAL, USER } from "@graphql";

export const useEditGoal = () => {
  return useMutation<EditGoalMutation, EditGoalMutationVariables>(EDIT_GOAL, {
    refetchQueries: [{ query: USER }],
    awaitRefetchQueries: true,
  });
};
